export default class DataValues {
  constructor (data, numeroPagina, range) {
    this.pagination = this.definePagination(range, data.length, numeroPagina)
    this.data = this.definirDadosDaPagina(data, numeroPagina, range)
    this.dataTableColumn = undefined
  }

  definePagination (range, qtdRegistros, numeroPagina) {
    const qtdPaginas = this.defineTotalPage(range, qtdRegistros)
    const paginaSelecionada = numeroPagina === undefined ? 1 : numeroPagina
    return {
      totalPage: qtdPaginas,
      hasPrev: paginaSelecionada > 1 ? 'true' : 'false',
      hasNext: paginaSelecionada < qtdPaginas ? 'true' : 'false',
      pageCount: range,
      totalReg: qtdRegistros,
      pageNumber: paginaSelecionada
    }
  }

  defineTotalPage (range, qtdRegistros) {
    let totalPage = parseInt(qtdRegistros / range)
    const resto = qtdRegistros % range

    if (resto > 0) {
      totalPage++
    }

    return totalPage
  }

  definirDadosDaPagina (data, numeroPagina, rowsNumber) {
    const paginaSelecionada = numeroPagina === undefined ? 1 : numeroPagina
    const offset = (paginaSelecionada - 1) * rowsNumber
    const range = (offset + rowsNumber) > data.length ? data.length : (offset + rowsNumber)

    return data.slice(offset, range)
  }
}
